/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import OrderSteps from '@/modules/service-point/components/order/order-steps/order-steps.component.vue';
import { servicePointStore } from '@/modules/service-point/store';

/**
 * Component.
 */
@Component({
  components: { 'order-steps': OrderSteps },
  name: 'collect-order-status-scene'
})
export default class extends Vue {
  /**
   * Getter `trackingNumberKey`.
   */
  get trackingNumberKey() {
    const trackingNumberKey = servicePointStore.deliverTrackingNumberKey;

    return trackingNumberKey;
  }

  /**
   * Getter `totalSteps`.
   */
  get totalSteps() {
    const { totalSteps = null } = this.$route.params || {};

    return Number(totalSteps) || 3;
  }

  /**
   * Lifecycle created.
   */
  async created() {
    const { trackingNumberKey } = this;

    if (!trackingNumberKey) {
      this.$router.push({
        name: 'ServicePointHome'
      });
    }
  }

  /**
   * Lifecycle before destroy hook.
   */
  beforeDestroy() {
    servicePointStore.setDeliverTrackingNumberKey(null);
  }

  /**
   * Handle go back.
   */
  handleGoback() {
    this.$router.push({
      name: 'ServicePointHome'
    });
  }
}
